
export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center gap-16">
          <div className="w-2/5">
            <div className="inline-block px-5 py-2 border-2 border-cyan-400 rounded-full mb-10">
              <span className="text-cyan-500 text-sm font-medium tracking-wide whitespace-nowrap">WHO WE ARE</span>
            </div>
            
            <h2 className="text-6xl font-extrabold text-black leading-tight mb-8">
              Protecting Your<br />
              Privacy Since<br />
              Day One
            </h2>
            
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              At FRIGOAVE RIO BRANCO LTDA, we believe that online privacy is a fundamental right. Our mission is to provide cutting-edge VPN solutions that empower individuals and businesses to browse the internet freely and securely.
            </p>
            
            <p className="text-gray-600 text-lg leading-relaxed mb-12">
              With years of expertise in cybersecurity and network infrastructure, we've built a robust platform that combines advanced encryption technology with user-friendly design, ensuring your digital footprint remains private.
            </p>
            
            <button className="px-10 py-4 bg-black text-white rounded-2xl font-medium hover:bg-gray-800 transition-colors whitespace-nowrap">
              Learn More About Us
            </button>
          </div>

          <div className="w-3/5">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/d3e7d57b29cbfa8783c398c63cc4a1b1.jpg"
                alt="Technology Infrastructure"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
